export type ConsentsData = {
  id: string | number;
  text: string;
  checked: boolean;
}

export type PDFEvent = {
  content: unknown;
  creditsDoc: number;
  csv: string;
  custodyEndDate: string;
  custodyIniDate: string;
  docOperation: number;
  documentStatus: string;
  externalId: string | number;
  facturae: number;
  fileNameWithExtension: string;
  generateFormDoc: boolean;
  hash: string;
  idDocument: string;
  metadataDocument: unknown;
  mustSignDoc: boolean;
  pdfSrc: string;
  status: boolean;
  statusConfirm: boolean;
  title: string;
  type: number;
  typeName: string;
}

export type InputData = {
  type: string;
  page: number;
  name: string;
  value?: string;
  id: string;
  checkbox: boolean;
  radioButton: boolean;
  position: {
    margin: number;
    padding: number;
    top: number;
    left: number;
    height: number;
    width: number;
  };
  readonly: boolean;
  fieldValue: string;
  checked: boolean;
  buttonValue: string;
}

export type WidgetPosition = {
  right?: string;
  bottom?: string;
  top?: string;
  left?: string;
  width?: string;
  height?: string;
}
export interface IntroTexts {
  title?: string;
  intro?: string;
  titleStep1?: string;
  titleStep2?: string;
  titleStep3?: string;
  titleStep4?: string;
  descriptionStep1?: string;
  descriptionStep2?: string;
  descriptionStep3?: string;
  descriptionStep4?: string;
}

export enum CustomTextType {
  PRESIGNVIEW = 'textWelcomePreSignView',
  POSTSIGNVIEW = 'textHelpPostSignView'
}
